import { render, staticRenderFns } from "./InventoryTransferForm.vue?vue&type=template&id=466cf728&"
import script from "./InventoryTransferForm.vue?vue&type=script&lang=js&"
export * from "./InventoryTransferForm.vue?vue&type=script&lang=js&"
import style0 from "./InventoryTransferForm.vue?vue&type=style&index=0&id=466cf728&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports